import ColorfulNavbar from './colorful-navbar';
export default ColorfulNavbar;
